var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIveyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 39,
    viewBox: "0 0 150 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.5029V39H2.41094H4.82189V19.5029V0.00584888H2.41094H0V19.5029ZM25.3157 0.168325L25.3771 0.3308L31.8058 19.6654L38.2347 39H41.3105H44.3864L50.8136 19.67L57.2407 0.339899L57.3062 0.169884L57.3714 0L54.9187 0.035484L52.466 0.0708391L46.9867 17.12L41.5073 34.1691L41.4324 34.2439L41.3573 34.3186L35.7634 17.1641L30.1694 0.00948832L27.7119 0.0076686L25.2544 0.00584888L25.3157 0.168325ZM77.8018 2.21552V4.42519H89.7913H101.781V2.21552V0.00584888H89.7913H77.8018V2.21552ZM126.399 12.4124L132.667 24.8242V31.9122V39H135.078H137.489V31.9808V24.9616L143.744 12.4837L150 0.00584888H147.336H144.672L140.566 8.09714L136.46 16.1884L135.754 17.5324L135.047 18.8764L130.298 9.47363L125.548 0.0708391L122.84 0.0356139L120.132 0.000519636L126.399 12.4124ZM77.8018 27.9517V39H90.052H102.302V36.7903V34.5807H92.4629H82.6237V27.8867V21.1927H91.4855H100.347V19.048V16.9033H89.0746H77.8018V27.9517Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIveyLogo);
export default __webpack_public_path__ + "static/media/ivey-logo.a8624718b7f662277aaa22113a1b2083.svg";
export { ForwardRef as ReactComponent };